import { Title } from "../../../stories/Title/Title";
import useFinancialYears from "../../Academics/hooks/useFinancialYears";
import useAcademicYears from "../../Academics/hooks/useAcademicYears";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import InstitutionTabs from "../routes/InstitutionTabs";
import { useNavigate } from "react-router-dom";
import { Button } from "../../../stories/Button/Button";
import { toStandardDate } from "../../../utils/UtilFunctions";

const ViewActiveYears = () => {
  const navigate = useNavigate();
  const { financialYearResponse } = useFinancialYears();
  const { academicYearResponse } = useAcademicYears();
  return (
    <>
      <InstitutionTabs />
      <Title>Active Years</Title>
      <div className="active-years">
        <div className="row g-0 active-years__datablock">
          <div className="col booktype-left h-100">
            <Title variant="subtitle1">Financial Year</Title>
            <div className="active-years__tableblock">
              <TableContainer className="active-years__tableblock--table">
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sl</TableCell>
                      <TableCell>Financial Year</TableCell>
                      <TableCell>Start Date</TableCell>
                      <TableCell>End Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {financialYearResponse.data?.GetFinYrsByInstId.map(
                      (year, index) => {
                        return (
                          <TableRow
                            className={
                              year.fin_is_curr_yr ? "activefinancialyear" : ""
                            }
                          >
                            <TableCell
                              id="td-center"
                              className="active-years__tableblock--table"
                            >
                              {index + 1}
                            </TableCell>
                            <TableCell>{year.fin_yr} </TableCell>
                            <TableCell>
                              {toStandardDate(year.fin_st_date)}
                            </TableCell>
                            <TableCell>
                              {toStandardDate(year.fin_end_date)}
                            </TableCell>
                          </TableRow>
                        );
                      }
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
          <div className="col booktype-right h-100">
            <Title variant="subtitle1">Academic Year</Title>
            <div className="active-years__tableblock">
              <TableContainer className="active-years__tableblock--table">
                <Table stickyHeader>
                  <TableHead>
                    <TableRow>
                      <TableCell>Sl</TableCell>
                      <TableCell>Academic Year</TableCell>
                      <TableCell>Start Date</TableCell>
                      <TableCell>End Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {academicYearResponse.data?.GetAcdYrsByInstId.map(
                      (year, index) => {
                        return (
                          <TableRow
                            className={
                              year.acd_is_curr_yr ? "activefinancialyear" : ""
                            }
                          >
                            <TableCell
                              id="td-center"
                              className="active-years__tableblock--table"
                            >
                              {index + 1}
                            </TableCell>
                            <TableCell>{year.acd_yr}</TableCell>
                            <TableCell>
                              {toStandardDate(year.acd_st_date)}
                            </TableCell>
                            <TableCell>
                              {toStandardDate(year.acd_end_date)}
                            </TableCell>
                          </TableRow>
                        );
                      }
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
        </div>
        <Button mode="back" onClick={() => navigate(-1)} />
      </div>
    </>
  );
};

export default ViewActiveYears;
